const MCAMapPinDark = () => {
	return (
		<>
			<path
				d="M32 5.33337C21.68 5.33337 13.3333 13.68 13.3333 24C13.3333 38 32 58.6667 32 58.6667C32 58.6667 50.6667 38 50.6667 24C50.6667 13.68 42.32 5.33337 32 5.33337Z"
				fill="#0B2341"
			/>
			<path
				d="M37.6462 16.7812C36.0676 16.7812 34.7755 17.7959 32.9621 19.333C32.133 17.5492 30.4855 16.8006 28.755 16.8006C27.1926 16.8006 25.516 18.0877 24.1635 19.2826L23.1298 17.1256H21.7461V31.1992H24.2228V20.0516C25.9672 18.9619 27.2378 18.6122 28.1628 18.6122C29.8006 18.6122 30.9183 20.1138 30.9183 22.2666V31.2003H33.395V21.6112C33.4057 21.0602 33.3416 20.5104 33.2044 19.9765C34.8832 18.9468 36.1204 18.6122 37.0217 18.6122C38.6595 18.6122 39.7772 20.1138 39.7772 22.2666V31.2003H42.2539V21.3774C42.2571 18.5607 40.3555 16.7812 37.6462 16.7812Z"
				fill="white"
			/>
		</>
	);
};

export default MCAMapPinDark;
